import { useMutation } from '@tanstack/react-query'
import { addShiftBonus } from 'api/shift'
import { AxiosError } from 'axios'
import { useAuthContext } from 'components/auth'

export function useAddShiftBonusMutation(options: {
  shiftId: number
  onSuccess?: () => void
  onError?: (err: AxiosError) => void
}) {
  const { shiftId, ...otherOptions } = options
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (bonus: number) => {
      if (!company?.id) {
        return
      }

      return addShiftBonus(company.id, shiftId, bonus)
    },
    ...otherOptions,
  })
}
